import { Phone } from "lucide-react";
import { DEALER } from "@/data/dealer";
import { gbp } from "@/lib/inventory";
import { useEnquiry } from "@/components/enquiry/EnquiryProvider";

export const MobileActionBar = ({ v }) => {
  const { openEnquiry } = useEnquiry();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-white/[0.98] px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 shadow-[0_-12px_30px_-20px_rgba(11,13,18,0.5)] lg:hidden"
      data-testid="mobile-action-bar"
    >
      <div className="mx-auto flex max-w-xl items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="truncate text-xs font-semibold text-steel">
            {v.year} {v.make} {v.model}
          </p>
          <p className="font-display text-xl font-extrabold leading-tight">{gbp(v.price)}</p>
        </div>
        <a href={DEALER.phone.href} aria-label={`Call ${DEALER.phone.display}`} className="btn btn-outline h-12 w-12 px-0" data-testid="mobile-action-call-link">
          <Phone aria-hidden="true" />
        </a>
        <button type="button" onClick={() => openEnquiry({ vehicleId: v.id, mode: "viewing" })} className="btn btn-outline h-12 px-3.5 text-sm" data-testid="mobile-action-viewing-button">
          Viewing
        </button>
        <button type="button" onClick={() => openEnquiry({ vehicleId: v.id, mode: "enquiry" })} className="btn btn-primary h-12 px-4 text-sm" data-testid="mobile-action-enquire-button">
          Enquire
        </button>
      </div>
    </div>
  );
};
